declare var cmn_schemeName: string;
declare var cmn_cartDomain: string;

let host = location.host;
let TestSite = ['aemtest.com', 'store-rev.modd.com'];


$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');

    // ページ全体の「会員」を「メンバー」に置換する
    //document.body.innerHTML = document.body.innerHTML.replace(/会員/g, "メンバー")

    // ページ全体の「ファンクラブ」を「メンバー」に置換する
    //document.body.innerHTML = document.body.innerHTML.replace(/ファンクラブ/g, "メンバー")

    // フッターの「利用規約」のリンク先を変更する
    // MODD側の元ソースでリンクを生成される都合上setTimeoutで処理を遅延させている
    const kiyakulink = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/kiyaku.aspx?ccode=HIAX"
    setTimeout(function(){
        $("#cmnfoot_button_kiyaku").attr("href", "").attr("href", kiyakulink)
    }, 300)



    // 【11/3では解除する】ヘッダーのお問い合わせのリンク先を変更
    // const fcContact = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/fc_contact.aspx?ccode=HIAX"
    // setTimeout(function(){
    //     $("#cmnhead_button_contact").attr("href", "").attr("href", fcContact)
    // }, 300)

    // 【11/3では解除する】ヘッダーのお問い合わせのリンク先を変更
    // const comKiyaku = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/fc_kiyaku.aspx?ccode=HIAX"
    // setTimeout(function(){
    //     $("#cmnfoot_button_comkiyaku").attr("href", "").attr("href", comKiyaku)
    // }, 300)



    // フッターのヘルプのリンク先を変更する
    setTimeout(function(){
        if (TestSite.indexOf(host) > -1) {
            $("#cmnhead_button_help").attr("href", "").attr("href", "https://team.hi-ax.dev06.axdv.me/faq/");
            $("#cmnfoot_button_help").attr("href", "").attr("href", "https://team.hi-ax.dev06.axdv.me/faq/")
        } else {
            $("#cmnhead_button_help").attr("href", "").attr("href", "https://team.hi-ax.com/faq/");
            $("#cmnfoot_button_help").attr("href", "").attr("href", "https://team.hi-ax.com/faq/")
        }
    }, 300)

    if (bodyId === 'Register') {
        pageRegister();
    } else if (bodyId === 'RegisterStep0') {
        RegisterStep0();
    } else if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'RegisterConf') {
        RegisterConf();
    } else if (bodyId === 'RegisterFin') {
        RegisterFin();
    } else if (bodyId === 'fcRegisterStep1') {
        FcRegisterStep1()
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'fc_contactFin') {
        FcContactFin()
    } else if (bodyId === 'com_help') {
        ComHelp()
    } else if (bodyId === 'com_contact') {
        ComContact()
    } else if (bodyId === 'com_kiyaku') {
        ComKiyaku()
    } else if (bodyId === 'privacy') {
        //Privacy()
    } else if (bodyId === 'contact') {
        //Contact()
    } else if (bodyId === 'Login') {
        Login()
    } else if (bodyId === 'FcCard') {
        FcCard()
    } else if (bodyId === 'fcKiyaku') {
        fcKiyaku();
    } else if (bodyId === 'fcPay') {
        fcPay();
    } else if (bodyId === 'fcPayConf') {
        fcPayConf();
    } else if (bodyId === 'fcPayComp') {
        fcPayComp();
    } else if (bodyId === 'fcPayment') {
        fcPayment();
    } else if (bodyId === 'fcPayThk') {
        fcPayThk();
    } else if (bodyId === 'fcPaymentDetails') {
        fcPaymentDetails();
    } else if (bodyId === 'FcCarrierAuthorize') {
        FcCarrierAuthorize();
    } else if (bodyId === 'CustCard') {
        CustCard();
    } else if (bodyId === 'fcJoin') {
        fcJoin();
    } else if (bodyId === 'com_register') {
        com_register();
    } else if (bodyId === 'CustomerRegister') {
        CustomerRegister();
    } else if (bodyId === 'fcJoinMail') {
        fcJoinMail()
    } else if (bodyId === 'fcJoinMailSend') {
        fcJoinMailSend();
    } else if (bodyId === 'fcJoinEntry') {
        fcJoinEntry();
    } else if (bodyId === 'fcJoinConf') {
        fcJoinConf();
    } else if (bodyId === 'fcJoinThk') {
        fcJoinThk();
    } else if (bodyId === 'CustomerEdit') {
        CustomerEdit();
    } else if (bodyId === 'CustomerEditFin') {
        CustomerEditFin();
    } else if (bodyId === 'CheckOut') {
        CheckOut();
    } else if (bodyId === 'help04') {
        help04();
    } else if (bodyId === 'help05') {
        help05();
    } else if (bodyId === 'OrderList') {
        OrderList();
    }
});


// Register
function pageRegister() {
    // $('.tblbody_email .table_control').prepend('<div class="mb-20"><a href="" target="_blank">【利用規約】</a>にご同意の上、メールアドレスを入力してください。</div>');

    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('2.会員情報を入力') > -1) {
            $(this).text('2.メンバー情報を入力');
        }
    });

    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録') > -1) {
            $(this).text('メンバー登録')
        }
    });

    const textDanger = $('.tblbody_email .message_area .text-danger').clone()

    $('.tblbody_email .message_area').html('※ご指定のメールアドレス宛にメンバー登録のご案内メールを送信いたします。')
    $('.tblbody_email .message_area').append(textDanger[0])

}

// RegisterStep0
function RegisterStep0() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録') > -1) {
            $(this).text('メンバー登録')
        }
    })
    $('.alert-success').html('メンバー登録のご案内メールを送信いたしました。<br>このメールでご案内したURLにアクセスしてメンバー情報の登録をおこなってください。')
}

// RegisterStep1
function RegisterStep1() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録') > -1) {
            $(this).text('メンバー登録')
        }
    })
    $('.t_message_center a').each(function(index){
        let $this = $(this)
        if (index == 0) {
            $(this).text('規約')
            const kiyakulink = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/com_kiyaku.aspx?ccode=HIAX"
            setTimeout(function(){
                $this.attr("href", "").attr("href", kiyakulink)
            }, 300)
        }
    })
}

// RegisterConf
function RegisterConf() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録内容の確認') > -1) {
            $(this).text('メンバー登録内容の確認')
        }
    })
}

// RegisterFin
function RegisterFin() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録完了') > -1) {
            $(this).text('メンバー登録完了')
        }
    })
    $('.alert-success').html('メンバー登録をしました。')
}

// FcRegisterStep1
function FcRegisterStep1() {

    if ($('#message_txt').text().indexOf('会員番号を入力してください') > -1) {
        $('#message_txt').text('メンバー番号を入力してください')
    }

    $('.t_message').each(function () {
        if ($(this).text().indexOf('ファンクラブ会員情報を入力してください') > -1) {
            $(this).text('メンバー情報を入力してください')
        }
    });

    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ') > -1) {
            $(this).text('メンバー')
        } else if ($(this).text().indexOf('会員番号') > -1) {
            $(this).text('メンバー番号')
        } else if ($(this).text().indexOf('会員有効期限') > -1) {
            $(this).text('メンバー有効期限')
        }
    });
}

    // MyPage
function MyPage() {

    // アコーディオンを開いておく
    $('#customer_header a').removeClass('collapsed').attr('aria-expanded', 'true');
    $('#customer_collapse').addClass('in');

    $('.table_header').each(function () {
        if ($(this).text().indexOf('ファンクラブ情報') > -1) {
            $(this).text('メンバー情報');
        } else if ($(this).text().indexOf('受付中のファンクラブ') > -1) {
            $(this).text('受付中のメンバー');
        }
    });

    $('.table_label').each(function () {
        if ($(this).text().indexOf('会員番号') > -1) {
            $(this).text('メンバー番号');
        } else if ($(this).text().indexOf('会員状態') > -1) {
            $(this).text('メンバー状態');
        } else if ($(this).text().indexOf('会員期限') > -1) {
            $(this).text('メンバー期限');
        }
    });

    $('.vct_fanclub').each(function () {
        if ($(this).text().indexOf('ファンクラブの入会情報はありません') > -1) {
            $(this).text('メンバーの入会情報はありません');
        }
    });

    $('.link_mypage').each(function () {
        if ($(this).text().indexOf('メンバー情報の登録（会員番号をお持ちの方）') > -1) {
            $(this).text('メンバー情報の登録（会員番号をお持ちの方）');
        }
    });

    $('#common_body a').each(function () {
        if ($(this).text().indexOf('会員情報') > -1) {
            if ($(this).attr('id') == 'custedit_lnk') {
                $(this).text('メンバー情報の変更')
            } else {
                $(this).text('メンバー情報')
            }
        } else if ($(this).text().indexOf('会員情報の変更') > -1) {
            $(this).text('メンバー情報の変更')
        } else if ($(this).text().indexOf('ファンクラブ情報の登録（会員番号をお持ちの方）') > -1) {
            $(this).text('メンバー情報の登録（メンバー番号をお持ちの方）')
        }
    })

    const kiyakulink = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/fc_kiyaku.aspx?ccode=HIAX"
    setTimeout(function(){
        $("#cmnfoot_button_kiyaku").attr("href", "").attr("href", kiyakulink)
    }, 300)
}

function FcContactFin() {
    // タイトル箇所差し替え
    $('.t_title').each(function () {
        if ($(this).text().indexOf('FCお問い合わせメール送信完了') > -1) {
            $(this).text('お問い合わせメール送信完了')
        }
    });
    $('.alert-success').each(function () {
        if ($(this).text().indexOf('ファンクラブお問い合わせメールを送信しました。') > -1) {
            $(this).text('お問い合わせメールを送信しました。');
        }
    });
}

function ComHelp() {

    // 「通販に関するご利用ガイドはこちら」を消す
    $('#com_help').find('.com_panel').each(function(index){
        if (index == 0) {
            //$(this).css('display', 'none')
        }
    })

    $('.panel-body a').each(function () {
        if ($(this).text().indexOf('ファンクラブに関するご利用ガイドはこちら') > -1) {
            $(this).text('メンバーに関するご利用ガイドはこちら');
        }
    });

}

function ComContact() {

    // 【11/3では解除する】「通販に関するお問合せはこちら」を消す
    // $('#com_contact').find('.com_panel').each(function(index){
    //     if (index == 0) {
    //         $(this).css('display', 'none')
    //     }

    //     if (index == 1) {
    //         $(this).find('.panel-footer').css('display', 'none')
    //     }
    // })


    $('.panel-body a').each(function () {
        if ($(this).text().indexOf('ファンクラブに関するお問合せはこちら') > -1) {
            $(this).text('オンラインサロンに関するお問い合わせ');
        }
    });
}

function ComKiyaku() {
    // 【11/3では解除する】「通販に関する利用規約はこちら」を消す
    // $('#com_kiyaku').find('.com_panel').each(function(index){
    //     if (index == 0) {
    //         $(this).css('display', 'none')
    //     }
    // })

    $('.panel-body a').each(function () {
        if ($(this).text().indexOf('ファンクラブに関する会員規約はこちら') > -1) {
            $(this).text('メンバーに関する利用規約はこちら');
        }
    });
}

function Privacy() {
    const kiyakulink = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/fc_kiyaku.aspx?ccode=HIAX"
    setTimeout(function(){
        $("#cmnfoot_button_kiyaku").attr("href", "").attr("href", kiyakulink)
    }, 300)
}

function Contact() {
    const kiyakulink = cmn_schemeName+'://'+cmn_cartDomain+'/'+"help/fc_kiyaku.aspx?ccode=HIAX"
    setTimeout(function(){
        $("#cmnfoot_button_kiyaku").attr("href", "").attr("href", kiyakulink)
    }, 300)
}

function Login() {

    $("#account").attr("placeholder" , "メールアドレス")

    $('.panel-heading').each(function () {
        if ($(this).text().indexOf('すでに会員の方はこちら') > -1) {
            $(this).text('すでにメンバーの方はこちら');
        } else if ($(this).text().indexOf('これから会員になる方はこちら') > -1) {
            $(this).html('<span>TEAM HI-AX STOREのみご利用の方はこちら<br>※TEAM HI-AXのコンテンツはご利用いただけません</span>')
        } else if ($(this).text().indexOf('ファンクラブ（有料）への入会を希望する方はこちら') > -1) {
            $(this).text('メンバー（有料）への入会を希望する方はこちら')
        }
    })

    const appedHtml = '<ul class="attention-list">' +
                        '<li>無料メンバーの方は、プルダウンは【選択してください】のまま、ご登録時の「メールアドレス」と「パスワード」を入力ください。</li>'+
                      '</ul>'


    $('.fcm_loginlist_text').text('')
    $('.fcm_loginlist_text').append(appedHtml)

    const CustomerRegister_lnk = $('#CustomerRegister_lnk').clone()
    $('.fc_register_panel').text('メンバー（有料）のメンバー番号をお持ちで、アカウント情報の登録がお済みでない方は、')
    $('.fc_register_panel').append(CustomerRegister_lnk)
}

function FcCard() {

    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ名') > -1) {
            $(this).text('メンバー種別')
        }
    });

    // 下部の注意事項のDOM
    const fcCardText = '<div class="ec_card_link link_guide_list"><a id="ec_card_lnk" class="link_ec" href="CustCard.aspx?ccode=HIAX">通販でご利用するクレジットカード情報の設定はこちら</a></div>'
    // 一度からにする
    $('.ec_card_link_note').text('')
    // htmlで挿入
    $('.ec_card_link_note').html('※カード情報の登録・変更をおこなうと自動でメンバーの継続処理がおこなわれます。<br>　自動継続を停止する場合はカード情報の削除をおこなってください。<br>※通販でご利用するクレジットカード情報とメンバーでご利用するクレジットカード情報は別々に設定をおこなってください。' + fcCardText)
}

function fcKiyaku() {

    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        }
    });

    $('#fccontinue_txt').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み');
        } else if ($(this).text().indexOf('ファンクラブ継続申込み') > -1) {
            $(this).text('メンバー継続申込み')
        } else if ($(this).text().indexOf('ファンクラブ申込み') > -1) {
            $(this).text('メンバー申込み')
        }
    });

    $('.t_message').each(function () {
        if ($(this).text().indexOf('会員規約を必ずお読みいただき、同意した上でお申込み手続きをおこなってください。') > -1) {
            $(this).text('メンバー規約を必ずお読みいただき、同意した上でお申込み手続きをおこなってください。');
        }
    })

    $('.panel-heading').each(function () {
        if ($(this).text().indexOf('会員規約') > -1) {
            $(this).text('メンバー規約');
        }
    })

}

function fcPay() {
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        }
    });
    $('#fccontinue_txt').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み');
        }
    });
}

function fcPayConf() {
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        }
    });
    $('#fccontinue_txt').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み');
        } else if ($(this).text().indexOf('ファンクラブ継続申込み') > -1) {
            $(this).text('メンバー継続申込み')
        }
    });
    $('#fccontinue2_txt').each(function () {
        if ($(this).text().indexOf('内容をご確認のうえ、ファンクラブの入会申込みをおこなってください。') > -1) {
            $(this).text('内容をご確認のうえ、メンバーの入会申込みをおこなってください。');
        } else if ($(this).text().indexOf('内容をご確認のうえ、ファンクラブの継続申込みをおこなってください。') > -1) {
            $(this).text('内容をご確認のうえ、メンバーの継続申込みをおこなってください。')
        }
    });

    if($('#message_txt').text().indexOf('ファンクラブ入会・継続申込みでエラーが発生しました。') > -1 && $('#message_txt').text().indexOf('お客様のカードはご利用いただけません。') > -1 ) {
        $('#message_txt').html('メンバー入会・継続申込みでエラーが発生しました。<br>お客様のカードはご利用いただけません。<br>恐れ入りますが、詳細はご利用のカード会社へお問い合わせください。')
    } else if($('#message_txt').text().indexOf('ファンクラブ入会・継続申込みでエラーが発生しました。') > -1 && $('#message_txt').text().indexOf('お支払情報の認証有効期限が切れました。') > -1 ) {
        $('#message_txt').html('メンバー入会・継続申込みでエラーが発生しました。<br>お支払情報の認証有効期限が切れました。<br>恐れ入りますが、再度お支払情報をご入力ください。')
    }
}

function fcPayComp() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });
}

function fcPayThk() {
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        }
    });
    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会・継続申込み') > -1) {
            $(this).text('メンバー入会・継続申込み')
        }
    });

    const fc_thanks_text = $('.fc_thanks_text').clone()

    $('.alert-success').html('お手続きいただきありがとうございました。<br>メンバー入会・継続申込みが完了しました。')
    $('.alert-success').prepend(fc_thanks_text)
}

function fcPayment() {
    $('.tbllst_itemlabel').each(function () {
        if ($(this).text().indexOf('ファンクラブ') > -1) {
            $(this).text('メンバー種別');
        }
    });
}

function fcPaymentDetails() {
    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ名') > -1) {
            $(this).text('メンバー種別');
        }
    });
}

function FcCarrierAuthorize() {
    $('.table_label').each(function () {
        if ($(this).text().indexOf('ファンクラブ名') > -1) {
            $(this).text('メンバー種別');
        }
    });
}

function CustCard() {
    const FcCardLink = $('.fc_card_link_note .fc_card_link').clone()

    $('.fc_card_link_note').html('※通販でご利用するクレジットカード情報とメンバーでご利用するクレジットカード情報は別々に設定をおこなってください。')
    $('.fc_card_link_note').append(FcCardLink[0])
}

function fcJoin() {
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        } else if ($(this).text().indexOf('3.会員情報を入力') > -1) {
            $(this).text('3.メンバー情報を入力')
        }
    });

    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });

    $('.panel-heading').each(function () {
        if ($(this).text().indexOf('会員規約') > -1) {
            $(this).text('メンバー規約');
        }
    })
}

function com_register() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録') > -1) {
            $(this).text('メンバー登録')
        }
    });
    $('.panel-heading').each(function () {
        if ($(this).text().indexOf('ファンクラブ（有料）への入会を希望する方はこちら') > -1) {
            $(this).text('メンバー（有料）への入会を希望する方はこちら');
        }
    })
}

function CustomerRegister() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員登録') > -1) {
            $(this).text('メンバー登録')
        }
    });
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('2.会員情報を入力') > -1) {
            $(this).text('2.メンバー情報を入力');
        }
    });
}

function fcJoinMail() {
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        } else if ($(this).text().indexOf('3.会員情報を入力') > -1) {
            $(this).text('3.メンバー情報を入力')
        }
    });

    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });

    $('.panel-heading').each(function () {
        if ($(this).text().indexOf('会員規約') > -1) {
            $(this).text('メンバー規約');
        }
    })

    const textDanger = $('.tblbody_email .message_area .text-danger').clone()

    $('.tblbody_email .message_area').html('※ご指定のメールアドレス宛にメンバー入会手続きのご案内メールを送信いたします。<br>※ご案内メールの中に記述されたURLにアクセスして新規入会手続きをおこなってください。')
    $('.tblbody_email .message_area').append(textDanger[0])
}

function fcJoinMailSend() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });
}

function fcJoinEntry() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });

    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        } else if ($(this).text().indexOf('3.会員情報を入力') > -1) {
            $(this).text('3.メンバー情報を入力')
        }
    });

    $('.t_message_center a').each(function(index){
        let $this = $(this)
        if (index == 0) {
            $(this).text('メンバー規約')
        }
    })

    // 自動継続更新のチェックボクスをonにする
    $('#card_fc_auto').prop('checked', true);
}

function fcJoinConf() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });

    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        } else if ($(this).text().indexOf('3.会員情報を入力') > -1) {
            $(this).text('3.メンバー情報を入力')
        }
    });

    $('.t_message').each(function () {
        if ($(this).text().indexOf('入力内容をご確認のうえ、ファンクラブの入会申込みをおこなってください。') > -1) {
            $(this).text('入力内容をご確認のうえ、メンバーの入会申込みをおこなってください。');
        }
    })

    if($('#message_txt').text().indexOf('ファンクラブ入会申込みでエラーが発生しました。') > -1 && $('#message_txt').text().indexOf('お客様のカードはご利用いただけません。') > -1 ) {
        $('#message_txt').html('メンバー入会・継続申込みでエラーが発生しました。<br>お客様のカードはご利用いただけません。<br>恐れ入りますが、詳細はご利用のカード会社へお問い合わせください。')
    } else if($('#message_txt').text().indexOf('ファンクラブ入会申込みでエラーが発生しました。') > -1 && $('#message_txt').text().indexOf('お支払情報の認証有効期限が切れました。') > -1 ) {
        $('#message_txt').html('メンバー入会・継続申込みでエラーが発生しました。<br>お支払情報の認証有効期限が切れました。<br>恐れ入りますが、再度お支払情報をご入力ください。')
    } else if($('#message_txt').text().indexOf('指定したメールアドレス（ログインアカウント）はすでに登録済みです。') > -1 && $('#message_txt').text().indexOf('一度ログインしてからマイページより再度ファンクラブ入会の手続きをおこなってください。') > -1 ) {
        $('#message_txt').html('指定したメールアドレス（ログインアカウント）はすでに登録済みです。<br>指定したメールアドレスがご本人のものならば、一度ログインしてからマイページより再度メンバー入会の手続きをおこなってください。')
    }
}

function fcJoinThk() {
    $('.flow_guide ul li').each(function () {
        if ($(this).text().indexOf('1.会員規約を確認') > -1) {
            $(this).text('1.メンバー規約を確認');
        } else if ($(this).text().indexOf('3.会員情報を入力') > -1) {
            $(this).text('3.メンバー情報を入力')
        }
    });

    $('.t_title').each(function () {
        if ($(this).text().indexOf('ファンクラブ入会申込み') > -1) {
            $(this).text('メンバー入会申込み')
        }
    });

    const fc_thanks_text = $('.fc_thanks_text').clone()

    $('.alert-success').html('メンバー入会申込みが完了しました。')
    $('.alert-success').prepend(fc_thanks_text)
}

function CustomerEdit() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員情報変更') > -1) {
            $(this).text('メンバー情報変更')
        } else if ($(this).text().indexOf('会員情報変更完了') > -1) {
            $(this).text('メンバー情報変更完了')
        }
    });
}

function CustomerEditFin() {
    $('.t_title').each(function () {
        if ($(this).text().indexOf('会員情報変更完了') > -1) {
            $(this).text('メンバー情報変更完了')
        }
    });
    $('.alert-success').each(function () {
        if ($(this).text().indexOf('会員情報を変更しました。') > -1) {
            // $(this).html('メンバー情報を変更しました。');
            // 11/3では解除 こっちを見るようにする
            $(this).html('メンバー情報を変更しました。<br>受取り前の注文がある場合、配送先の変更は「ご注文履歴」から手続きを行ってください。');
        }
    });

}

function CheckOut() {
    $('.link_ec').each(function () {
        if ($(this).text().indexOf('会員規約') > -1) {
            $(this).text('利用規約')
        }
    })
}

function help04() {
    $('#h02').next().find('.panel-body').find('span').remove();
    $('#h02').next().find('.panel-body').append('<p>１回の発送につき、¥880（税込）の送料がかかります。<br>※日本国内への配送のみとさせていただいております。<br>※沖縄県は￥2,020（税込）となります</p>')

    $('#h07').next().find('.panel-body').find('p').remove();
    $('#h07').next().find('.panel-body').append('<p>●クレジットカードご利用の場合<br>商品に同梱されている「納品書 兼 領収書」を領収書としてご利用ください。<br>※納品書の再発行は承っておりませんので、あらかじめご了承ください。<br><br>●コンビニ支払いの場合<br>各コンビニ払込受領証をもって領収書とさせていただきます。</p>')

    $('#h04').next().find('.panel-body').find('p').remove();
    $('.panel-footer').css('display', 'none');
}

function help05() {
    $('.panel-footer').css('display', 'none');
}

function OrderList() {
    const text = '<div class="col-xs-12 com_panel">' +
                    '<div class="panel panel-default">' +
                        '<div class="panel-body">' +
                            '<div class="panel-body__title panel-body__title--alert">注文状態ステータス変更のお知らせ</div>' +
                            '注文状態につきまして、これまで「配達済み」を最終ステータスとして表示しておりましたが、システム変更のため2021年6月より順次「出荷済み」が最終ステータスとなります。<br>' +
                            '配達状況については、「詳細」→「配達伝票No.」より、佐川急便サイトにてご確認いただきますようお願い申し上げます。<br>' +
                        '</div>' +
                    '</div>' +
                '</div>'
    $('#panel_cust_bar').before(text);
}